var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.additionalClass},[(_vm.title)?_c('div',{staticClass:"title is-2",class:_vm.additionalTitleClass},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subTitle)?_c('div',{staticClass:"subtitle is-4",class:_vm.additionalSubTitleClass},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }